<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Sidebar manual -->
<aside class="fixed left-0 top-0 z-50 flex h-full flex-col bg-white text-black print:hidden"
    [style.width.px]="280"
    [style.transform]="sidebarOpen() ? 'translateX(0)' : 'translateX(-100%)'"
    style="transition: transform 0.3s ease;">

    <!-- Logo -->
    <div class="flex h-20 flex-col items-center p-6 pb-0">
        <img src="images/logo/htasistlogo2.png" class="w-40" />
    </div>
    <!-- Selector de módulo -->
    <mat-form-field appearance="outline" class="mx-4 mb-2">
        <mat-label>Módulo</mat-label>
        <mat-select
            aria-label="Seleccionar módulo"
            [value]="selectedModuleId()"
            (selectionChange)="selectModule($event.value)">
            @for (module of modules(); track module.id) {
                <mat-option [value]="module.id">{{ module.title }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <!-- Opciones del módulo seleccionado -->
    <div class="flex-1 overflow-y-auto py-2">
        <nav class="flex flex-col" [attr.aria-label]="selectedModule()?.title ?? 'Menú principal'">
            @for (item of selectedMenuItems(); track item.id) {
                <a [routerLink]="item.link"
                    class="flex items-center gap-3 px-6 py-2.5 text-sm text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900"
                    routerLinkActive="bg-gray-100 text-gray-900">
                    @if (item.icon) {
                        <mat-icon class="h-5 w-5 shrink-0 text-gray-400" [svgIcon]="item.icon"></mat-icon>
                    }
                    <span class="flex-1 truncate">{{ item.title }}</span>
                </a>
            } @empty {
                @if (!navLoading()) {
                    <p class="px-6 py-3 text-sm text-gray-500">No hay opciones disponibles.</p>
                }
            }
        </nav>
    </div>

    <!-- Footer -->
    <div class="border-t">
        <div class="mx-4 my-2">
            <app-tenant-badge variant="full"></app-tenant-badge>
        </div>
<!-- Lo comentaree para que no lo vean los usuarios de pruebas-->
        <!-- @if (isDev) {
            <div class="mx-4 mb-3 rounded-lg border border-amber-200 bg-amber-50 text-[11px] text-amber-800">
                <button class="flex w-full items-center gap-1.5 rounded-lg px-4 py-2 font-semibold text-amber-700 hover:bg-amber-100"
                        (click)="devPanelExpanded = !devPanelExpanded">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" />
                    </svg>
                    DEV
                    <svg xmlns="http://www.w3.org/2000/svg" class="ml-auto h-3 w-3 transition-transform" [class.rotate-180]="devPanelExpanded" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                </button>
                @if (devPanelExpanded) {
                    <div class="space-y-1 px-4 pb-3">
                        @if (user) {
                            <div class="flex gap-1"><span class="w-14 shrink-0 text-amber-600">UserId</span><span class="truncate font-mono">{{ user.userId }}</span></div>
                            <div class="flex gap-1"><span class="w-14 shrink-0 text-amber-600">Email</span><span class="truncate">{{ user.email }}</span></div>
                        }
                        @if (tenantService.currentTenant()?.tenantId) {
                            <div class="flex gap-1"><span class="w-14 shrink-0 text-amber-600">TenantId</span><span class="font-mono">{{ tenantService.currentTenant()?.tenantId }}</span></div>
                        }
                        <div class="flex gap-1"><span class="w-14 shrink-0 text-amber-600">EmpresaId</span><span class="font-mono">{{ empresaService.currentEmpresa()?.id ?? '—' }}</span></div>
                        <div class="flex gap-1"><span class="w-14 shrink-0 text-amber-600">SucursalId</span><span class="font-mono">{{ sucursalContext.currentSucursal()?.id ?? '—' }}</span></div>
                        <a class="mt-2 inline-flex items-center gap-1 rounded bg-amber-100 px-3 py-2 font-semibold text-amber-800 hover:bg-amber-200" routerLink="/dev-debug">
                            Abrir diagnóstico DEV
                        </a>
                    </div>
                }
            </div>
        } -->

        <div class="flex w-full items-center border-t px-6 py-4">
            <user></user>
            <div class="ml-4 flex w-full flex-col overflow-hidden">
                <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-black leading-normal text-current opacity-80">
                    {{ user?.name }}
                </div>
            </div>
        </div>
    </div>
</aside>

<!-- Overlay para móvil -->
@if (isScreenSmall && sidebarOpen()) {
    <div class="fixed inset-0 z-40 bg-black/50" (click)="sidebarOpen.set(false)"></div>
}

<!-- Contenido principal -->
<div class="flex min-w-0 flex-auto flex-col text-black"
    [style.margin-left.px]="sidebarOpen() ? 280 : 0"
    style="transition: margin-left 0.3s ease;">

    <!-- Header -->
    <div class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
        <button class="mr-2" mat-icon-button (click)="toggleNavigation()">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>

        <app-tenant-badge variant="inline"></app-tenant-badge>

        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <app-tenant-switcher></app-tenant-switcher>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <app-impersonation-banner></app-impersonation-banner>
        <router-outlet></router-outlet>
    </div>
</div>
